<article class=`str-item-card ${input.class}` ...input.testId>
    <str-watch-icon
        page=input.page
        itemId=input.itemId
        iconSize="SMALL"
        itemCardWatch=input.itemCardWatch
    />
    <if(input.isAjax)>
        <${input.link ? "a" : "span"} onClick("fetchCategoryListings", input.link) aria-hidden="true" class="str-item-card__link" href=input.link _sp=input.sid
            data-track=input.trackingData tabindex="-1" data-carousel-tabindex="-1">
            <str-ordered-properties-header ...input testId="card-ajax-true"/>
        </>
    </if>
    <else-if(input.isQuickviewEnabled)>
        <str-ordered-properties-header ...input testId="card-quickview"/>
    </else-if>
    <else>
        <${input.link ? "a" : "span"} aria-hidden="true" class="str-item-card__link" href=input.link _sp=input.sid data-track=input.trackingData
            target=(input.openLinkInNewTab && "_blank") tabindex="-1" data-carousel-tabindex="-1">
            <str-ordered-properties-header ...input testId="card-ajax-false"/>
        </>
    </else>
    <div.str-item-card__signals-container>
        <div.str-item-card__signals> // flex 1
            <str-ordered-properties-content ...input/>
        </div>
        <if(input.entityOverflow)>
            <entity-overflow-button/>
        </if>
    </div>
</article>

<macro name="entity-overflow-button">
    <ebay-menu-button
        class="str-item-card__overflow-button"
        variant="overflow"
        reverse=true
        size="small"
        collapseOnSelect=true
        a11y-text=input.entityOverflow.icon?.accessibilityText>
        <for|entry| of=input.entityOverflow.menuItems?.entries>
            <@item>
                <str-textual-display ...entry.label/>
            </@item>
        </for>
    </ebay-menu-button>
</macro>
